'use client';
import { useRef, useState, useCallback } from 'react';

var useHover = function(options) {
    var timeout = (options || {}).timeout;
    var timerRef = useRef(0);
    var _useState = useState(false), hovered = _useState[0], setHovered = _useState[1];
    var onMouseEnter = useCallback(function() {
        if (timeout) {
            window.clearTimeout(timerRef.current);
        }
        setHovered(true);
    }, []);
    var onMouseLeave = useCallback(function() {
        if (timeout) {
            timerRef.current = window.setTimeout(function() {
                return setHovered(false);
            }, timeout);
        } else {
            setHovered(false);
        }
    }, []);
    return [
        hovered,
        {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }
    ];
};

export { useHover };
